<base-modal class="base-modal ecfik-notes-modal" [title]="title" isProfileMode="false" [disableFocusManagement]="true">
  <div class="panel-body ecfik-notes-wrapper">
    <!-- HEADER AND ADD BUTTON -->
    <div class="header-container">
      <div class="text-and-close">
        <nv-icon-button
          [name]="'close-large-blue'"
          type="button"
          [ariaLabel]="'Close'"
          [title]="'Close'"
          (clickButton)="close()"
        ></nv-icon-button>
        <h2>{{ title }}</h2>
        <nv-pill
          *ngIf="pillText"
          [color]="pillColor"
        >{{ pillText }}</nv-pill>
      </div>
      <div *ngIf="modalControl === 'STUDENT'" class="align-right">
        <nv-button
            [icon]="'note-add-small-blue'"
            size="small"
            type="secondary"
            [disabled]="false"
            (click)="onAddNote()"
        >Add note
        </nv-button>
      </div>
     </div>
    <!--TABLE-->
    <div class="grid-container" *ngIf="showGrid">
      <ag-grid-angular
        class="ag-theme-alpine"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [modules]="modules"
        (gridReady)="onGridReady($event)"
        (cellClicked)="onCellClicked($event)"
        [rowData]="rowData"
      >
      </ag-grid-angular>
    </div>

    <!-- CUSTOM PAGINATOR -->
    <paginator-controls
        *ngIf="rowData?.length > 0"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [totalRows]="totalRows"
        [pageSize]="pageSize"
        (onBtNext)="onBtNext($event)"
        (onBtPrevious)="onBtPrevious($event)"
    ></paginator-controls>
  </div>
</base-modal>
